import './list-zero-workflow.scss';

interface DocsComingSoonProps {
  product: string;
}

/*
 * Stands in until a product's documentation is written, so its section in the
 * docs sidebar leads somewhere instead of being an empty group.
 */
export default function DocsComingSoon({ product }: DocsComingSoonProps) {
  return (
    <div className="list-zero-workflow">
      <div className="workflow-card">
        <h2>{product} Documentation</h2>
        <p>Coming soon</p>
      </div>
    </div>
  );
}
